import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arc-log-contact_enquiry",
  "use": "icon-Arc-log-contact_enquiry-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Arc-log-contact_enquiry\">\n<path d=\"M3.66683 16.5H5.50016V20.2409L10.1761 16.5H14.6668C15.6779 16.5 16.5002 15.6778 16.5002 14.6667V7.33333C16.5002 6.32225 15.6779 5.5 14.6668 5.5H3.66683C2.65575 5.5 1.8335 6.32225 1.8335 7.33333V14.6667C1.8335 15.6778 2.65575 16.5 3.66683 16.5Z\" fill=\"currentColor\" />\n<path d=\"M18.3333 1.83334H7.33333C6.32225 1.83334 5.5 2.65559 5.5 3.66668H16.5C17.5111 3.66668 18.3333 4.48893 18.3333 5.50001V12.8333C19.3444 12.8333 20.1667 12.0111 20.1667 11V3.66668C20.1667 2.65559 19.3444 1.83334 18.3333 1.83334Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/Arc-log-contact_enquiry.svg
// module id = HCnO
// module chunks = 258